const demand_units = [
    ['kw', 'kW'],
    ['kva', 'kVA'],
];

export default demand_units;